import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";

import baseUserContextComponent from "../baseUserContextComponent";
import { CategoryFavouriteViewModel } from "@/models/categoryFavouriteViewModel";
@Component({})
export default class categoryFavouriteFilter extends baseUserContextComponent {
    @Prop({ default: () => [] })
    categories: CategoryFavouriteViewModel[];
    @Prop({ default: () => null })
    categoryId: string;

    @Prop({ default: () => "" })
    title: string | null;
    @Prop({ default: () => "" })
    cssClass: string | null;

    get showCategories() {
        return this.categories != null && this.categories.length > 0;
    }

    onClick(c: CategoryFavouriteViewModel) {
        this.$emit("select", c);
    }

    onNewCategoryClick() {
        this.$emit("on-new-category");
    }

    editCategoryClick(c: CategoryFavouriteViewModel) {
        this.$emit("on-edit-category", c);
    }

    deleteCategoryClick(c: CategoryFavouriteViewModel) {
        this.$emit("on-delete-category", c);
    }
}
